import { useDispatch } from 'react-redux';

import { updateCoverPhoto } from 'actions/projects';
import eventEmitter from 'helpers/event-emitter';
import { PROJECT_FEATURED_PHOTO_CHANGED } from 'constants/graphqlEvents';

const NO_ACTION = null;
const NO_MODAL = () => {};
const EMPTY_RESULT = [NO_ACTION, NO_MODAL];

const databaseIdFrom = (obj) => parseInt(obj.databaseId, 10);

export default function useMenuActionSetCoverPhoto({
  assets,
  assetsByType,
  onSuccess,
}) {
  const dispatch = useDispatch();

  const hasPermission = true;
  const validSelection =
    assets.length === 1 && assetsByType.photos.length === 1;

  if (!hasPermission || !validSelection) {
    return EMPTY_RESULT;
  }

  const action = async () => {
    const photo = assetsByType.photos[0];
    if (!photo) {
      return;
    }

    await dispatch(
      updateCoverPhoto(
        databaseIdFrom(photo.projectInfo),
        databaseIdFrom(photo),
      ),
    );
    eventEmitter.trigger(PROJECT_FEATURED_PHOTO_CHANGED);
    onSuccess?.();
  };

  return [action, NO_MODAL];
}
